import { ReactNode } from "react";
import { hasPermission, hasAnyPermission, isAdmin, isTenantUser } from "@/hooks/usePermissions";

interface PermissionGuardProps {
  children: ReactNode;
  permission?: string;
  permissions?: string[];
  requireAll?: boolean;
  adminOnly?: boolean;
  tenantUserOnly?: boolean;
  fallback?: ReactNode;
}

export const PermissionGuard = ({
  children,
  permission,
  permissions,
  requireAll = false,
  adminOnly = false,
  tenantUserOnly = false,
  fallback = null,
}: PermissionGuardProps) => {
  if (adminOnly && !isAdmin()) {
    return <>{fallback}</>;
  }

  if (tenantUserOnly && !isTenantUser()) {
    return <>{fallback}</>;
  }

  if (permission && !hasPermission(permission)) {
    return <>{fallback}</>;
  }

  if (permissions && permissions.length > 0) {
    if (requireAll) {
      const hasAllPermissions = permissions.every(perm => hasPermission(perm));
      if (!hasAllPermissions) {
        return <>{fallback}</>;
      }
    } else {
      // Requer pelo menos uma permissão
      if (!hasAnyPermission(permissions)) {
        return <>{fallback}</>;
      }
    }
  }

  return <>{children}</>;
};

// Hook para usar permissões diretamente em componentes funcionais
export const usePermissionCheck = () => {
  return {
    hasPermission,
    hasAnyPermission,
    isAdmin,
    isTenantUser,
  };
};